// extracted by mini-css-extract-plugin
export var bodyRow = "_de-d";
export var cardColumns = "_de-e";
export var ellipsesOverflow = "_de-2";
export var flatBottomCorners = "_de-3";
export var flatTopCorners = "_de-4";
export var headerActionsDropdown = "_de-f";
export var headerBottomRow = "_de-c";
export var headerTopRow = "_de-b";
export var orderDetailsWrapper = "_de-0";
export var orderInfoContainer = "_de-1";
export var productDetails = "_de-9";
export var productImage = "_de-5";
export var responsiveTable = "_de-8";
export var shipmentContainer = "_de-a";
export var tableBottomLeft = "_de-6";
export var tableBottomRight = "_de-7";
export var trackingLink = "_de-g";